import styled from "styled-components";

export const Table = styled.table`
  width: 890px;
  position: relative;
  right: 80px;
  text-align: center;
  border-collapse: collapse;
  border: 1px solid #fff;
  border-collapse: collapse;
  height: 100px;
  color: rgb(199, 16, 16);
  font-size: 13px;
  text-transform: capitalize;
  font-weight: 500;
  letter-spacing: 0.25px;
`;

export const TBody = styled.tbody`
  border: 1px solid #fff;
  border-collapse: collapse;
  width: 1650px;
  height: 100px;
`;
export const Tr = styled.tr`
  border: 1px solid #fff;
  border-collapse: collapse;
  width: 1650px;
  height: 100px;
  color: #fff;
  font-size: 13px;
  text-transform: capitalize;
  font-weight: 500;
  letter-spacing: 0.25px;
`;
export const Td = styled.td`
  border: 1px solid #fff;
  border-collapse: collapse;
  width: 1650px;
  height: 100px;
  color: #fff;
  font-size: 13px;
  text-transform: capitalize;
  font-weight: 500;
  letter-spacing: 0.25px;
`;
